/**
 * Reporting without an account.
 *
 * The browser keeps a **device key** so a reader can be shown the outcome of
 * their own report later. It is deliberately not an identity: it cannot be
 * used to find them, it is never sent anywhere but with their own report,
 * and clearing the browser loses it. That is the correct trade for a feature
 * that must not require signing in.
 */

const DEVICE_KEY = 'mimbar.reporter.device';

export function deviceKey(): string {
  try {
    const existing = localStorage.getItem(DEVICE_KEY);
    if (existing) return existing;
    const made = crypto.randomUUID();
    localStorage.setItem(DEVICE_KEY, made);
    return made;
  } catch {
    // Private browsing, or storage blocked. The report still files; the
    // reader just cannot be shown its outcome later.
    return '';
  }
}

/** What the reporting device is told, per status. */
export const REPORT_STATUS_TEXT: Record<string, string> = {
  open: 'The reviewers have it.',
  accepted: 'Being checked.',
  rejected: 'Looked at — the translation stands.',
  resolved: 'Fixed after your report.',
};

export const REPORT_KINDS = [
  ['translation', 'The meaning is wrong, or something is missing'],
  ['learning', 'A word meaning or grammar note is wrong'],
  ['citation', 'The Qur’an or hadith reference is wrong'],
  ['other', 'Something else'],
] as const;
